import { render } from "./primaryProcessTesting.vue?vue&type=template&id=f3948b0a&scoped=true"
import script from "./primaryProcessTesting.vue?vue&type=script&lang=js"
export * from "./primaryProcessTesting.vue?vue&type=script&lang=js"

import "./primaryProcessTesting.vue?vue&type=style&index=0&id=f3948b0a&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3948b0a"]])

export default __exports__